interface Die {
    step: number,
    d6: number,
    mod: number
}

export const dice = (() => {
    let dice: Die[] = [];
    dice.push({step: 1, d6: 1, mod: -2});
    dice.push({step: 2, d6: 1, mod: -1});

    for (let step = 3; step < 61; step++) {
        dice.push({
            step: step, d6: Math.floor(step / 3), mod: (step % 3)
        });
    }

    return dice;
})();

export function getDie(step) {
    const die = dice.filter((obj) => {
        return obj.step === step;
    }).shift();
    if (die) return die;
    return {step: 1, d6: 1, mod: -2};
}


